import _t from 'i18n!nls/xdp';

const getGoogleCourseDescription = (slug: string) => {
  switch (slug) {
    case 'google-ai-essentials':
      return _t(
        'Learn from experts at Google and get essential AI skills to boost your productivity with Google AI Essentials, zero experience required.'
      );
    case 'google-prompting-essentials':
      return _t(
        'Learn to give clear and specific instructions to generative AI in 5 easy steps. Get help creating content, analyzing data, and summarizing information with Google Prompting Essentials. No experience necessary.'
      );
    default:
      return '';
  }
};

export default getGoogleCourseDescription;
